// import store from '@/store'

export default {

  navigateToPage (router, pageExtname, path) {
    // console.log('navigating to: ' + pageExtname + "/" + path)
    router.push('/seite/' + pageExtname + '/' + path)
  },

  navigateToDefaultPage(router, pageExtname, studyName, viewName, path) {
    const fullPath = '/seite/' + pageExtname + '/' + studyName + "/" + viewName + "/" + path;
    router.push(fullPath)
  },

  navigateToInterviewPage (router, studyName, path) {
    // console.log('navigating to interviewPage: ' +interviewId )
    router.push('/interview/' + studyName + '/' + path)
  },

  navigateToUserListPage (router, studyName) {
    // console.log('navigating to UsersPage: ')
    router.push('/users/'+studyName)
  },

  navigateToUserPage (router, userId) {
    // console.log('navigating to userPage: ' + userId )
    router.push('/user/' + userId)
  },

  navigateToReportsPage (router, studyName) {
    if(router.currentRoute.name!=='reports') {
      // console.log('navigating to ReportsPage')
      router.push('/reports/' + studyName)
    }
  },

  navigateToSettingsPage (router, studyName) {
    if(router.currentRoute.name!=='settings') {
      // console.log('navigating to SettingsPage')
      router.push('/settings/' + studyName)
    }
  },

  isOnReportsPage (router) {
    return router.currentRoute.name==='reports'
  }


}
